import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MasterDataQuery } from '../../../services/query';
import { ETBSCS } from '../emailTemplateBuilder.classes';

interface SearchableCountrySelectProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    fullWidth?: boolean;
    style?: React.CSSProperties;
}

export const SearchableCountrySelect: React.FC<SearchableCountrySelectProps> = ({
    value,
    onChange,
    label,
    fullWidth = true,
    style,
}) => {
    const { t } = useTranslation();
    const [countryList, setCountryList] = useState<any[]>([]);
    const [filteredCountryList, setFilteredCountryList] = useState<any[]>([]);

    useEffect(() => {
        GetCountryList();
    }, []);

    const GetCountryList = async () => {
        try {
            const serviceResponse: any = await MasterDataQuery.GetCountryList();
            const parseData = serviceResponse.data.map((item: any) => {
                return {
                    id: item.countryId,
                    key: item.countryKey,
                    name: item.countryCode,
                    dropdownValueText: item.translatedCountryName || item.countryCode,
                };
            });
            setCountryList(parseData);
            setFilteredCountryList(parseData);
        } catch (error) {
            console.error('Error fetching country list:', error);
        }
    };

    const handleCountrySearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const searchText = event.target.value.toLowerCase();

        if (countryList) {
            const filtered = countryList.filter((country: any) =>
                country.dropdownValueText.toLowerCase().includes(searchText)
            );
            setFilteredCountryList(filtered);
        }
    };

    return (
        <Autocomplete
            className={ETBSCS.root}
            options={filteredCountryList || []}
            getOptionLabel={(option: any) => option?.dropdownValueText || ''}
            value={filteredCountryList?.find((item: any) => item?.name === value) || null}
            onChange={(_, newValue) => {
                onChange(newValue?.name || '');
            }}
            slotProps={{
                popper: {
                    sx: { zIndex: (theme) => theme.zIndex.modal + 1 },
                },
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    className={ETBSCS.inputAutocomplete}
                    label={label || t('emailTemplateBuilder.selectCountryName')}
                    onChange={handleCountrySearch}
                />
            )}
            disablePortal
            sx={{
                width: fullWidth ? '100%' : '345px',
                '& .MuiOutlinedInput-root': {
                    height: '40px !important',
                    minHeight: '40px !important',
                    maxHeight: '40px !important',
                    '&.Mui-focused, &.Mui-selected, &:hover': {
                        height: '40px !important',
                        minHeight: '40px !important',
                        maxHeight: '40px !important',
                    },
                },
                '& .MuiInputBase-input': {
                    height: '8px !important',
                    minHeight: '8px !important',
                    padding: '8px 14px !important',
                },
                ...style,
            }}
        />
    );
};
